import { D3Selection } from "svg/draw/draw-calendar";
import { CoverInfo, CustomImage, ImageDetails } from "burde";
import { BleedSize, CalendarSizeDimensions } from "svg/constants";
import { getImageUrlByCalendarSize } from "svg/helpers";

const drawBackPage = (
    svg: D3Selection,
    calendarSize: string,
    calendarDimensions: CalendarSizeDimensions,
    backCoverImage: ImageDetails | null,
    backCoverColor: string | null,
    customBackImage: CustomImage | null,
) => {
    var background = svg.append("g").classed("background-content", true);

    if (customBackImage) {
        background
            .append("svg:image")
            .attr("x", 0)
            .attr("y", 0)
            .attr("width", calendarDimensions.svgWidth)
            .attr("height", calendarDimensions.svgHeight)
            .attr("xlink:href", `${customBackImage.url}`)
            .attr("preserveAspectRatio", "xMidYMid slice");
    } else if (backCoverImage && backCoverImage.id !== null) {
        background
            .append("svg:image")
            .attr("x", 0)
            .attr("y", 0)
            .attr("width", calendarDimensions.svgWidth)
            .attr("height", calendarDimensions.svgHeight)
            .attr(
                "xlink:href",
                backCoverImage.endpoints &&
                    getImageUrlByCalendarSize(
                        backCoverImage.endpoints,
                        calendarSize,
                    ),
            )
            .attr("preserveAspectRatio", "xMidYMid slice");
    } else if (backCoverColor) {
        background
            .append("rect")
            .attr("width", calendarDimensions.svgWidth)
            .attr("height", calendarDimensions.svgHeight)
            .attr("fill", backCoverColor);
    }

    // Content coordinate system will start at 0 0 for upper left and will not take bleeds in to account
    let content = svg
        .append("g")
        .attr("transform", `translate(${BleedSize}, ${BleedSize})`)
        .classed("main-content", true);
};

export { drawBackPage };
